import React, { useState, useMemo } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  myInforChangeStateRecoil,
} from '../../atom/ModalAtom';
import { MyInforDto, MyInforChangeDto } from '../../model/user.dto';
import { userIdState } from '../../atom/TokenAtom';
import { authAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';

interface MyInforChangeProps {
  myInfors: MyInforDto | null;
  onListUpdate: () => void;
}

const MyInforChange = ({ myInfors, onListUpdate }: MyInforChangeProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(myInforChangeStateRecoil);

  const [userNumber, setUserNumber] = useState(myInfors?.userNumber);
  const [otherText, setOtherText] = useState(myInfors?.otherText);
  const [nickName, setNickName] = useState(myInfors?.nickname);
  const [nickNameCertification, setNickNameCertification] = useState(false);
  const [otherTextLength, setOtherTextLength] = useState(
    myInfors?.otherText?.length,
  );

  const handleNicknameCheck = async () => {
    if (nickName === '') {
      setError('닉네임을 입력해 주세요.');
      return;
    }

    try {
      await authAPI.nicknameCheck(String(nickName));
      setConfirm('사용 가능한 닉네임입니다.');
      setNickNameCertification(true);
    } catch (err: any) {
      setError('중복된 닉네임입니다.');
    }
  };

  const handleConfirm = async () => {
    if (userNumber === '' || nickName === '') {
      setError(blankMsg);
      return;
    }

    if (!nickNameCertification && nickName !== myInfors?.nickname) {
      setError('닉네임 중복확인을 해주세요.');
      return;
    }

    const dto: MyInforChangeDto = {
      phone: myInfors?.phone || '',
      userNumber: userNumber || '',
      otherText: otherText || '',
      nickname: nickName || '',
    };
    try {
      await authAPI.putMyInfor(dto);
      setModalState(false);
      setConfirm('성공적으로 수정되었습니다.');
      onListUpdate();
    } catch (error) {
      setModalState(false);
      setError('수정에 실패했습니다.');
    }
  };

  return (
    <>
      <InputModal
        title="정보 변경"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>
              번호
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              type="text"
              placeholder="사번 등 입력"
              value={userNumber}
              onChange={(e) => setUserNumber(e.target.value)}
              aria-label="사번 등 입력 필드"
            />
          </li>
          <li>
            <h2>기타사항({otherTextLength}/15)</h2>
            <CS.TextInputType1
              type="text"
              placeholder="기타사항 입력"
              value={otherText}
              onChange={(e) => {
                if (e.target.value.length > 15) {
                  setError('기타사항은 15자 이하로 입력해 주세요.');
                  return;
                } else {
                  setOtherText(e.target.value);
                  setOtherTextLength(e.target.value.length);
                }
              }}
              aria-label="기타사항 입력 필드"
            />
          </li>
          <li>
            <h2>
              닉네임
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1CheckBtnWrap>
              <CS.TextInputType1
                type="text"
                placeholder="닉네임 입력"
                value={nickName}
                onChange={(e) => {
                  setNickName(e.target.value);
                  setNickNameCertification(false);
                }}
                aria-label="닉네임 입력 필드"
              />
              <button
                type="button"
                onClick={handleNicknameCheck}
                disabled={nickNameCertification}
              >
                {nickNameCertification ? '완료' : '중복확인'}
              </button>
            </CS.TextInputType1CheckBtnWrap>
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default MyInforChange;
